export default "__VITE_ASSET__CMkgQu$4__"